import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_wd64rb2zkz_thi_27eaa95ae2: FaireThemeEntity = {
  token: "board_demo_r_wd64rb2zkz_thi_27eaa95ae2",
  type: "theme",
  retailerToken: "r_wd64rb2zkz",
  name: "The Iowa Shop",
  description:
    "Celebrate your local roots with Iowa-made rattles and handmade treasures that highlight your store's connection to the state.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/ac970b7c865ff162bf9fd59c2ace547623649c5ef5d48ba53046cc757930ab5e.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/ac970b7c865ff162bf9fd59c2ace547623649c5ef5d48ba53046cc757930ab5e.jpeg",
    "https://cdn.faire.com/fastly/4321390e4dbff2b6f9c27f243056012483ffdaec6e80d23c09e76e384333c2ed.jpeg",
    "https://cdn.faire.com/fastly/88e21705cf6047fb60e487928158020763fdee5ca627f350fb8b5170af6255e6.jpeg",
    "https://cdn.faire.com/fastly/98f166ace4ead9680cf5ac398b8465e08ab5a0aeb4f44270efc05223b53dad95.jpeg",
    "https://cdn.faire.com/fastly/7e089da23d9d811c0b14a94c849f51520cb99d8af5286a1fcba320edb6fbf546.jpeg",
    "https://cdn.faire.com/fastly/321adc66aad27caa498ac86e63c8afb573362c65e1a4e525531782a55b45a40a.jpeg",
  ],
  itemCount: 56,
  source: "eric_themes_ideas",
  teaser: "thi_27eaa95ae2",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
